import { render, staticRenderFns } from "./cmpCreate.vue?vue&type=template&id=5f80dd26&"
import script from "./cmpCreate.vue?vue&type=script&lang=js&"
export * from "./cmpCreate.vue?vue&type=script&lang=js&"
import style0 from "./cmpCreate.vue?vue&type=style&index=0&id=5f80dd26&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports